module.exports = __webpack_public_path__ + "img/starinvestama.ef4a4c54.png";